import React, { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import homeNavIcon from 'assets/images/home-nav-icon.png';
import Styles from 'views/home/Home.module.scss';

/** Marketing-site chrome for public article pages (guests). */
const PublicSiteNav: FunctionComponent = () => {
  const history = useHistory();

  return (
    <nav className={Styles.nav}>
      <div className={Styles.navInner}>
        <div
          className={Styles.navBrand}
          onClick={() => history.push('/home')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              history.push('/home');
            }
          }}
          role="button"
          tabIndex={0}
          aria-label="Moderate Politics home"
          style={{ cursor: 'pointer' }}
        >
          <img src={homeNavIcon} alt="" className={Styles.navIcon} />
          <span className={Styles.navName}>Moderate Politics</span>
        </div>
        <button className={Styles.navLogin} type="button" onClick={() => history.push('/login')}>
          Login
        </button>
      </div>
    </nav>
  );
};

export default PublicSiteNav;
